import { PRICING_RULE_TYPES } from '../constants/appConstants';

/**
 * Client-facing unit price from base list price, using the client user's pricing rule.
 * Mirrors server/utils/pricing.js calculateClientPrice.
 */
export function calculateClientPrice(basePrice, carat, clientUser) {
  const pricingRule = clientUser?.pricingRule;
  if (!pricingRule || pricingRule.type === PRICING_RULE_TYPES.NONE) {
    return basePrice;
  }

  let finalPrice = basePrice;

  switch (pricingRule.type) {
    case PRICING_RULE_TYPES.FIXED_PER_CARAT:
      finalPrice = basePrice + pricingRule.value;
      break;
    case PRICING_RULE_TYPES.PERCENTAGE:
      finalPrice = basePrice * (1 + pricingRule.value / 100);
      break;
    default:
      return basePrice;
  }

  return Math.max(0, finalPrice);
}
